import * as React from "react";
import { List, Datagrid, TextField, ImageField, Filter, TextInput, useLocale } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
    theme => ({
        image: {
            borderRadius: '5px',
            width: 'auto',
            maxHeight: '40px',
        }
    }));

const SignpostingFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn resettable />
    </Filter>
);

export const SignpostingList = (props) => {
    const classes = useStyles();
    const locale = useLocale();

    return (
        <List title={"Sinalética"} {...props} filters={<SignpostingFilter />} sort={{ field: 'createdAt', order: 'DESC' }}>
            <Datagrid rowClick="edit">
                <ImageField source="image[src]" label="Imagem" classes={classes} />
                <TextField source={`title[${locale}]`} label="Título" />
            </Datagrid>
        </List>
    )
};

export default SignpostingList;